<script>
import { HorizontalBar } from 'vue-chartjs';

export default {
  name: 'HorizontalBarChart',
  extends: HorizontalBar,
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    chartOptions: {
      type: Object,
      default: () => ({ responsive: true, maintainAspectRatio: false }),
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.$data._chart?.destroy();
        this.renderChart(this.chartData, this.chartOptions);
      },
    },
  },
};
</script>
